const isProduction = () => window.location.hostname === 'top-conv.com'

const config = {
    environment: 'dev',
    version: 'v2',
    apiUrl: "https://api-competitive-staging.bizzw.com",
    product: {
        normal: {
            en: "pro_6060269095f80e0869ef3f89",
            fr: "pro_605c63aa05bb7500196eae1f",
            es: "pro_6060269a95f80e0869ef3f8a"
        },
        selfEmployed: {
            en: "pro_6694c700ec0d3423813903e1",
            fr: "pro_6694c66fec0d3423813903de",
            es: "pro_6694c74dec0d3423813903e3"
        },
        company: {
            en: "pro_6694c71cec0d3423813903e2",
            fr: "pro_6694c6b1ec0d3423813903e0",
            es: "pro_6694c76bec0d3423813903e4"
        }
    },
    actions: {
        forgotPassword: {
            en: "act_6061dfd195f80e0869ef3fbe",
            fr: "act_6061df5ab1253800191864bb",
            es: "act_6061dfe795f80e0869ef3fbf"
        },
        successPassword: {
            en: "act_68d2e05bec08b6b738aaa3f7",
            fr: "act_68d2e0deec08b6b738aaa3fa",
            es: "act_68d2e09eec08b6b738aaa3f9"
        },
        unsubscribe: {
            fr: "act_59425c9ac147fb001190c2a6",
            en: "act_606ebe2e055e7a5970da34d5",
            es: "act_606ebe38055e7a5970da34d6"
        },
        conversion: {
            en: "act_606d6a3d055e7a5970da349d",
            fr: "act_606d69d9fd0246001930dcf8",
            es: "act_606d6a6e055e7a5970da349e"
        }
    },
    website: {
        nameTemplate: "app-file-converter-{{lng}}-v2",
        tradEnv: "staging"
    },
    serviceConverter: {
        url: "https://service-converter-staging.bizzw.com"
    },
    google: {
        clientId: "421821265057-5lq26db608ve36m17ms3cjvehdh1of2c.apps.googleusercontent.com",
        key: "AIzaSyABhPWEAuFb4ia6s2hWUZ_0K0tqwIX7sZA"
    },
    companyName: 'rwl'
}

if (window.location.hostname === 'app-file-converter-v2.bizzw.com') {
    config.environment = 'staging';
    config.google.key = 'AIzaSyC_imV34G6aXF9mLkquIAr7QioBw5P4q5k'
}

if (isProduction()) {
    config.environment = 'production';
    config.version = 'v2';
    config.website.nameTemplate = "{{lng}}.top-conv.com";
    config.website.tradEnv = "live";
    config.serviceConverter.url = "https://service-converter.bizzw.com";
    config.gtm = "GTM-PDW29HM";
    config.google.key = "AIzaSyC_imV34G6aXF9mLkquIAr7QioBw5P4q5k";
    config.apiUrl = "https://api-competitive.bizzw.com";
    config.actions.conversion = {
        en: "act_606d6abf055e7a5970da34a4",
        es: "act_606d6acb055e7a5970da34a5",
        fr: "act_606d6ab0055e7a5970da34a3"
    }

    config.actions.forgotPassword = {
        en: "act_664c7a66c38cd8004140b237",
        es: "act_664c7a9ac38cd8004140b238",
        fr: "act_664c7a0fc38cd8004140b236"
    }

    config.actions.unsubscribe = {
        en: "act_5db05583c5b69c1804cd6ac0",
        es: "act_5d9500b2b1035218d7696a97",
        fr: "act_591b0b20d228ac000f24a8a0"
    }

    config.product = {
        normal: {
            en: "pro_6180e695cd80cd3a92bf44ff",
            es: "pro_6180e6f5cd80cd3a92bf4502",
            fr: "pro_6180e619cd80cd3a92bf44f7"
        },
        selfEmployed: {
            en: "pro_6694c867ec0d3423813903e7",
            es: "pro_6694c8e5ec0d3423813903ea",
            fr: "pro_6694c93dec0d3423813903ec"
        },
        company: {
            en: "pro_6694c8a2ec0d3423813903e9",
            es: "pro_6694c900ec0d3423813903eb",
            fr: "pro_6694c954ec0d3423813903ed"
        }
    }
}

export default config;